module.exports = __webpack_public_path__ + "ab-testing.svg?46c8140dfd0443c92158eef563debeea";